import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import withTeam from '../../lib/with-team';
import NoBackground from '../../components/club-frame/header/no-background';
import PageDataLoadError from '../../components/errors/page-data-load-error';
import SquadList from '../../components/team/squad';
import { fetchPageData } from '../../store/teams/squad/actions';
import {
  isLoading,
  hasLoaded,
  getLoadingError,
  getPlayersByTeamId,
  getStaffAndCoachesByTeamId,
} from '../../store/teams/squad/selectors';
import CLUB_PROP_TYPES from '../../lib/prop-types/club';
import TEAM_PROP_TYPES from '../../lib/prop-types/team';
import LOADING_ERROR_PROP_TYPES from '../../lib/prop-types/loading-error';
import PROFILES_PROP_TYPES from '../../lib/prop-types/profile';
import SeoHead from '../../components/seo';

class TeamSquadPage extends React.Component {
  static async getInitialProps({ reduxStore, club, isServer, team, req, res }) {
    const initialProps = {
      activeSubSection: 'squad',
      pageType: 'team.squad.index',
    };

    if (!isServer) {
      return initialProps;
    }

    const { error, accessLevel } = await reduxStore.dispatch(fetchPageData(club.id, team.id, req));

    if (error && error.errorStatusCode && res) {
      res.statusCode = error.errorStatusCode;
    }

    if (accessLevel && accessLevel === 'private') {
      res.doNotCache = true;
    }

    return initialProps;
  }

  componentDidMount() {
    const {
      loading,
      previouslyLoaded,
      loadPageData,
      club: { id: clubId },
      team: { id: teamId },
    } = this.props;

    if (!loading && !previouslyLoaded) {
      loadPageData(clubId, teamId);
    }
  }

  render() {
    const { loading, loadingError, club, team, staffAndCoaches, players } = this.props;

    if (loadingError) {
      return (
        <PageDataLoadError
          clubId={club.id}
          {...loadingError}
          accessDeniedTranslationKey="teams:profiles_access_denied"
        />
      );
    }

    return (
      <>
        <SeoHead
          club={club}
          descriptionTranslationKey="teams:squad_meta_description"
          route="team.squad"
          routeParams={{ teamId: team.id }}
          translationValues={{ teamName: team.name }}
          titleTranslationKey="teams:squad_page_title"
        />
        <NoBackground />
        <SquadList
          club={club}
          teamId={team.id}
          isLoading={loading}
          staffAndCoaches={staffAndCoaches}
          players={players}
        />
      </>
    );
  }
}

TeamSquadPage.defaultProps = {
  loadingError: null,
  staffAndCoaches: [],
  players: [],
};

TeamSquadPage.propTypes = {
  loading: PropTypes.bool.isRequired,
  previouslyLoaded: PropTypes.bool.isRequired,
  loadingError: LOADING_ERROR_PROP_TYPES,
  loadPageData: PropTypes.func.isRequired,
  club: CLUB_PROP_TYPES.isRequired,
  team: TEAM_PROP_TYPES.isRequired,
  staffAndCoaches: PROFILES_PROP_TYPES,
  players: PROFILES_PROP_TYPES,
};

const dispatchToProps = {
  loadPageData: fetchPageData,
};

const mapStateToProps = (state, { teamId }) => ({
  loading: isLoading(state, teamId),
  previouslyLoaded: hasLoaded(state, teamId),
  loadingError: getLoadingError(state, teamId),
  staffAndCoaches: getStaffAndCoachesByTeamId(state, teamId),
  players: getPlayersByTeamId(state, teamId),
});

export default withTeam(connect(mapStateToProps, dispatchToProps)(TeamSquadPage));
